import {NOT_EDIT_CHANGE_REQUEST_STATUSES} from 'src/modules/constants';
import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

import {StringFilterItem} from '../typedefs';

type Params = {
    changeRequestsMapped: StringFilterItem[],
    code: string,
    source: string,
    userEmail: string,
};

export const findNotEditChangeRequest = ({
    changeRequestsMapped,
    code,
    source,
    userEmail,
}: Params) => changeRequestsMapped.find(request =>
    code && source
    && request.source === source
    && request.name === code
    && (NOT_EDIT_CHANGE_REQUEST_STATUSES.includes(request.status as ChangeRequestStatus)
        && request.authorEmail === userEmail || request.authorEmail !== userEmail),
);
